import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { Store } from "state/store";
import { AboutYourLoanForm } from "components/AboutYourLoan/AboutYourLoanForm";
import { AboutYourLoan } from "domain/aboutYourLoan";
import { YOUR_BOUNCE_BACK_LOAN_URL } from "App.const";
import { ABOUT_YOUR_LOAN_SCREEN_TITLE } from "./Title.const";

export type AboutYourLoanScreenProps = {
  store: Store;
};

const AboutYourLoanScreen = ({ store }: AboutYourLoanScreenProps) => {
  document.title = ABOUT_YOUR_LOAN_SCREEN_TITLE;
  const navigate = useNavigate();

  const handleSubmit = (aboutYourLoan: AboutYourLoan) => {
    store.aboutYourLoanStore.storeAboutYourLoan(aboutYourLoan);
    navigate(YOUR_BOUNCE_BACK_LOAN_URL, { replace: true });
  };

  return (
    <>
      <AboutYourLoanForm
        aboutYourLoan={store.aboutYourLoanStore.data}
        onSubmit={handleSubmit}
      />
    </>
  );
};

const AboutYourLoanScreenObserver = observer(AboutYourLoanScreen);
export { AboutYourLoanScreenObserver as AboutYourLoanScreen };
